import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { View } from 'foundations-components/components/View';
import { useDebounce } from '../../../app/hooks/useDebounce';
import { useEffect, useState } from 'react';
import { useGetQueryParam } from '../../../app/hooks/useGetQueryParam';
import { useSetQueryParams } from '../../../app/hooks/useSetQueryParams';
import usePrevious from 'react-utils/hooks/usePrevious';
import { TrackingAction, TrackingFeature, TrackingScreen, trackUsage } from '../../../app/utils/tracking';
import { getTrackingSubscreenTab } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const categoryLabelMapping = {
  all: 'all',
  'in-beta': 'inBeta',
  'in-development': 'inDevelopment',
  live: 'live',
  'new-to-you': 'newToYou',
  recommended: 'recommended',
  sunset: 'sunset',
  'scheduled-for-release': 'scheduledForRelease',
  'your-betas': 'yourBetas'
};
export default function ProductUpdatesSearch({
  category
}) {
  const valueFromQs = useGetQueryParam('query') || '';
  const [query, setQuery] = useState(valueFromQs);
  const setQueryParams = useSetQueryParams();
  const queryDebounced = useDebounce(query, 500);
  const prevValueFromQsRef = usePrevious(valueFromQs);
  useEffect(() => {
    if (valueFromQs !== queryDebounced) {
      if (valueFromQs === prevValueFromQsRef) {
        setQueryParams({
          query: queryDebounced,
          offset: ''
        });
        trackUsage(TrackingScreen.PRODUCT_UPDATES, getTrackingSubscreenTab(category), TrackingFeature.SEARCH_BAR, TrackingAction.SEARCH);
      } else {
        setQuery(valueFromQs);
      }
    }
    // eslint-disable-next-line
  }, [queryDebounced, valueFromQs]);
  const label = I18n.text(`app.filters.search.${categoryLabelMapping[category]}`);
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": label,
    children: /*#__PURE__*/_jsx(View, {
      minInlineSize: "250px",
      children: /*#__PURE__*/_jsx(SearchInput, {
        onChange: ({
          target: {
            value
          }
        }) => {
          setQuery(value);
        },
        placeholder: label,
        value: query
      })
    })
  });
}